<template>
	<div class="ticket-resume">
		<md-dialog-alert
	      :md-active.sync="alert"
	      :md-content="msg"
	      md-confirm-text="Ok" />
		<md-card class="md-layout-item md-size-100 md-small-size-100" style="height: 100%;">
			<md-card-content style="height: 100%;">
				<div class="md-layout md-gutter">
					<div class="md-layout-item md-size-50">
						<div class="md-layout">
							<div class="md-layout-item">
								<label for="punter">Apostador</label>
							</div>
						</div>
						<div class="md-layout">
							<div class="md-layout-item">
								<input type="text" v-model="bet_punter" class="resume-input" v-on:change="$emit('updatePunter', $event.target.value)"/>
							</div>
						</div>
					</div>
					<div class="md-layout-item md-size-50">
						<div class="md-layout">
							<div class="md-layout-item">
								<label for="value">Valor</label>
							</div>
						</div>
						<div class="md-layout">
							<div class="md-layout-item">
								<money v-model="bet_value" v-bind="money" class="resume-input" @keyup.native="updateValue()" value=""></money>
							</div>
						</div>
					</div>
				</div>
				<div class="md-layout title-subeventos-selecionados">
					JOGOS SELECIONADOS
				</div>
				<div class="md-layout" style="height: 65%;height: 65%;overflow: auto;">
					<div class="md-layout-item resume-subeventos-selecionados">
						<div class="md-layout subevent-selecionado" v-for="subevento in selected">
							<div class="md-layout-item md-size-85">
								<div class="md-layout" >
									<div class="md-layout-item" style="font-weight: bold; color: #868686; font-size: 80%;">
										<!-- {{ subevento.dia }} {{ subevento.evento.horario }} -->
										{{ showData(subevento) }}
									</div>
								</div>
								<div class="md-layout" >
									<div class="md-layout-item" style="font-size: 90%;">
										{{ showTitulo(subevento) }}
									</div>
								</div>
								<div class="md-layout" >
									<div class="md-layout-item" style=" font-size: 90%;">
										{{ subevento.titulo }}: {{ subevento.fulllabel }} - {{ subevento.cotacao }}
									</div>
								</div>
							</div>
							<div class="md-layout-item md-size-15 md-alignment-center-center" style="line-height: 4;text-align: right;" v-on:click="$emit('removeSelected', subevento)">
								<md-icon >delete_outline</md-icon>
							</div>
						</div>
					</div>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-size-35">
						<md-button class="md-raised md-primary" v-on:click="$emit('clearTicket')">LIMPAR</md-button>
					</div>
					<div class="md-layout-item md-size-65">
						<md-button class="md-raised md-primary" v-on:click="finish()">CONCLUIR APOSTA</md-button>
					</div>
				</div>
			</md-card-content>
		</md-card>
		
	</div>
</template>
<script>

	import axios from 'axios'
	import { Money } from 'v-money'

	export default {
		name: 'TitanResume',
		components: {
			Money
		},
		props: ['selected', 'punter', 'value'],
		data() {
			return {
				bet_punter: "",
				bet_value: this.value,
				money: {
		          decimal: ',',
		          thousands: '.',
		          prefix: 'R$ ',
		          precision: 2,
		          masked: false
		        },
		        alert: false,
			    msg: ""
			}
		},
		watch: {
			value(val) {
			  this.bet_value = val
			},
			punter(val) {
				this.bet_punter = val
			}
		},
		methods: {
			updateValue: function() {
				//Precisa fazer desta forma por causa do money
				this.$emit('updateValue', this.bet_value)
			},
			showData: function(subevento){
				if (subevento.dia) {
					return subevento.dia + " - " + subevento.evento.horario
				} else {
					return subevento.evento.schedule
				}
			},
			showTitulo: function(subevento) {
				if (subevento.dia) {
					return subevento.evento.casa + " x " + subevento.evento.fora
				}
				else {
					return subevento.evento.nome
				}
			},
			finish: function(){
				var jsonBet = {};
				jsonBet.bet_punter = this.punter;
				jsonBet.bet_value = this.value
				jsonBet.odds = [];

				for (var i = 0; i < this.selected.length; i++) {
					var betOdd = {};
					betOdd.bet_odd_odd_id = this.selected[i].id
					betOdd.bet_odd_value = this.selected[i].cotacao

					jsonBet.odds.push(betOdd)
				}

				var form = new FormData();
				form.append("data", JSON.stringify(jsonBet));

				if (this.$store.state.usuario) {
					var config = {
					  headers: {'Content-Type': 'application/x-www-form-urlencoded', Authorization: 'Bearer  ' + this.$store.state.usuario.token}
					};
				}
				else {
					var config = {
					  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
					};
				}

				//console.log(config);

				var v = this;
				axios.post(this.$root.$data.API_URL + (this.$store.state.usuario ? 'seller/bet' : 'bet'), form, config)
				.then(function (response) {
			        // console.log(response);
		        	let result = response.data
					if (result.success) {
						if (v.$store.state.usuario) {
							v.$router.push({ name: 'TitanReprint', params: { id: result.betId }})
						}
						else {
							v.$router.push({ name: 'TitanTicket', params: { id: result.betId }})
						}
					}
					else {
						if (result.code != undefined && result.code == 'timeLimit') {
							var id = result.id
							var subevento = {}
							for (var i = 0; i < v.selected.length; i++) {
								if (id == v.selected[i].id) {
									subevento = v.selected[i]
									v.selected.splice(i, 1)
									break;
								}
							}
							v.msg = "O evento " + v.showTitulo(subevento) + " expirou. Por favor, reconfirme sua aposta."
						}
						else if (result.code != undefined && result.code == 'differentOdd') {
							var id = result.id
							var valor = result.value
							var subevento = {}
							for (var i = 0; i < v.selected.length; i++) {
								if (id == v.selected[i].id) {
									subevento = v.selected[i]
									subevento.cotacao = valor
									v.selected.splice(i, 1, subevento)
									break;
								}
							}
							v.msg = "Ocorreu uma alteração no valor da cotação do evento " + v.showTitulo(subevento) + ". Por favor, verifique seu bilhete."
						}
						else {
							v.msg = result.message
						}

						v.alert = true
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme
</style>


// WEBPACK FOOTER //
// src/components/TitanResume.vue